import axios, {AxiosResponse} from "axios";
import {PlacesResponse} from "./types";

export const lookupAddressInput = (input: string) => {
    if (!input) {
        return Promise.resolve({
           places: []
        });
    }
    return axios.post<object, AxiosResponse<PlacesResponse>>(`https://places.googleapis.com/v1/places:searchText`, {
        textQuery: input,
        includedType: "locality"
    }, {
        headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': 'AIzaSyA1mL-ckUvYiKSYdm_Lknrri3QX3p2Y-gY',
            'X-Goog-FieldMask': 'places.formattedAddress,places.location,places.id,places.googleMapsUri,places.postalAddress.locality,places.postalAddress.regionCode'
        }
    }).then(r => r.data);
}